import { AsyncPipe } from '@angular/common';
import { AfterViewInit, Component, ElementRef, OnDestroy } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { CmsService, Page, RoutingService, WindowRef } from '@spartacus/core';
import {
  GlobalMessageComponentModule,
  HamburgerMenuService,
  KeyboardFocusModule,
  KeyboardFocusService,
  OutletModule,
  OutletRefModule,
  PageLayoutModule,
  PageSlotModule,
  SkipLinkModule,
  StorefrontComponent
} from '@spartacus/storefront';
import { Subscription } from 'rxjs';
import { RecaptchaModule } from 'src/app/spartacus/features/recaptcha/recaptcha.module';
import { CustomStorefrontService } from './custom-storefront.service';

@Component({
  selector: 'cx-storefront',
  templateUrl: './custom-storefront.component.html',
  styleUrls: ['./custom-storefront.component.scss'],
  imports: [
    AsyncPipe,
    RouterModule,
    GlobalMessageComponentModule,
    OutletModule,
    OutletRefModule,
    PageLayoutModule,
    PageSlotModule,
    KeyboardFocusModule,
    SkipLinkModule,
    RecaptchaModule
  ]
})
export class CustomStorefrontComponent extends StorefrontComponent implements AfterViewInit, OnDestroy {
  private currentSite: string = this.winRef.localStorage?.getItem('currentSite');
  private pathname: string = this.winRef.nativeWindow?.location.pathname;
  protected subscriptions: Subscription = new Subscription();

  constructor(
    hamburgerMenuService: HamburgerMenuService,
    routingService: RoutingService,
    elementRef: ElementRef<HTMLElement>,
    keyboardFocusService: KeyboardFocusService,
    protected customStorefrontService: CustomStorefrontService,
    private cmsService: CmsService,
    private meta: Meta,
    protected winRef: WindowRef
  ) {
    super(hamburgerMenuService, routingService, elementRef, keyboardFocusService);
  }

  onActivate(event): void {
    this.winRef.nativeWindow?.scroll(0, 0);
  }

  collapseMenuIfClickOutside(event: any): void {
    const element = event.target;
    if (element.nodeName.toLowerCase() === 'header' && element.className.includes('is-expanded')) {
      this.collapseMenu();
    }
  }

  ngAfterViewInit(): void {
    this.currentSite = this.winRef.localStorage?.getItem('currentSite');
    this.pathname = this.winRef.nativeWindow?.location?.pathname;
    if (this.pathname === '/es/') {
      this.winRef.localStorage?.setItem('currentSite', 'ohgar');
    } else if (!this.pathname?.substr(13).includes(this.currentSite)) {
      this.winRef.localStorage?.setItem('currentSite', this.pathname?.substr(13));
    }

    this.subscriptions.add(
      this.cmsService.getCurrentPage().subscribe((currentPage: Page) => {
        if (currentPage?.pageId?.indexOf('homepage') > -1) {
          this.meta.updateTag({ name: 'canonical', content: this.winRef.location.href });
        } else {
          if (currentPage?.pageId?.indexOf('productDetails') < 0) {
            this.meta.removeTag('name="canonical"');
          }
        }
      })
    );
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.meta.removeTag('name="canonical"');
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
